import { FieldWrapper } from 'components/rich/rich-input'
import { useRichContext } from 'context/rich-context'
import { useFormikContext } from 'formik'
import { ToolHolder } from 'lib/assets/types/tool-holder'
import { Tool_V1 } from 'lib/assets/types/tool_v1'
import { convertToUnitSystem, prepareAssetData } from 'lib/rich'
import { FC, InputHTMLAttributes, useMemo } from 'react'
import { Segment, SegmentsViewer } from './segments-viewer'
import { geometryToSegments } from './tool-segments'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
  labelClassName?: string
  wrapper?: FieldWrapper
}

export const HolderPreview: FC<Props> = ({
  name,
  className,
  labelClassName,
  wrapper: Wrapper,
  ...props
}) => {
  const { values } = useFormikContext<Tool_V1 & ToolHolder.Data>()
  const { metric } = useRichContext()

  const segments = useMemo<Segment[]>(() => {
    if (values?.holder) {
      // Holder on a tool case
      const holder: ToolHolder.Data = structuredClone(values.holder)

      let tool = prepareAssetData(values, Tool_V1.getFieldSpecs()) as any
      if (tool.unit !== holder.unit) {
        // Convert holder to match tool unit
        convertToUnitSystem(holder, ToolHolder.Spec, tool.unit === 'mm')
      }

      const toolSegments = geometryToSegments(tool)
      toolSegments.forEach((segment) => {
        segment.group = 'tool'
      })

      return [...holder.segments, ...toolSegments]
    } else if (values?.segments) {
      // Holder asset (no tool)
      const holder: ToolHolder.Data = values
      return holder.segments
    } else {
      return []
    }
  }, [values])

  return (
    <SegmentsViewer
      segments={segments}
      defaultGroup="holder"
      zoomGroup={undefined}
      metric={metric}
      width={340}
      height={240}
    />
  )
}
